<div class="tdcf-tools">
    <button
        type="button"
        class="btn btn-primary"
        (click)="onExportDataClick()"
    >
        {{ i18n._7213_EXPORT_DATA | translate }}
    </button>
</div>

<div
    grid
    [columns]="dataSource?.columns"
    [gridTpl]="gridTpl"
    [rowTpl]="rowTpl"
    #grid="grid"
></div>

<ng-template #gridTpl>
    <table class="table"></table>
</ng-template>

<ng-template #rowTpl>
    <tr></tr>
</ng-template>

<ng-template
    #thTpl
    let-c="c"
>
    <th>
        <div>{{ columnName(c) | translate }}</div>
    </th>
</ng-template>

<ng-template
    #tdTpl
    let-c="c"
    let-l="l"
>
    <td>
        <div>{{ cellValue(c, l) | translate }}</div>
    </td>
</ng-template>
